import { useQuery } from '@tanstack/react-query';

import { MeasureSolutionResponseItem } from '@e-origin/contracts';
import { SortDirection } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const MEASURE_SOLUTIONS_QUERY_KEY = 'measure-solutions';

export interface MeasureSolutionCriteria {
  filters: { searchQuery?: string };
  pagination: { page: number; size: number };
  sorting: { field: string; direction: SortDirection };
}

export const defaultMeasureSolutionCriteria: MeasureSolutionCriteria = {
  filters: { searchQuery: '' },
  pagination: { page: 1, size: 10 },
  sorting: { field: 'createdAt', direction: SortDirection.DESC },
};

const EMPTY = { data: { measureSolutions: [] as MeasureSolutionResponseItem[], totalItems: 0 } };

export const useMeasureSolutions = (criteria: MeasureSolutionCriteria = defaultMeasureSolutionCriteria) => {
  return useQuery({
    queryKey: [MEASURE_SOLUTIONS_QUERY_KEY, criteria],
    queryFn: async () => {
      try {
        const result = await apiClient.measureSolutions.retrieveMeasureSolutions.mutation({ body: { criteria } });
        if (result.status === 200) {
          return result.body || EMPTY;
        }
        throw new Error(`Unexpected response status: ${result.status}`);
      } catch (error) {
        showErrorToast(error, 'Failed to fetch preferred measure solutions');
        return EMPTY;
      }
    },
  });
};
